module.exports = __webpack_public_path__ + "static/media/matija-krizmanic.e805c46f.jpg";